// @flow
import React, { Component } from 'react';
import { Collapse } from 'reactstrap';

import Toggle from './Toggle';
import Toggler from '../../../UI/Toggler';

type Props = {
  name: string,
  note: string,
  charge: Object,
  is_locked: boolean,
  is_available: boolean,
  isGuided: boolean,
  quantity: number,
  per_day: boolean,
  per_person: boolean,
  per_group: boolean,
  prefCost: number,
  updatePref: Function,
};

type State = {
  is_available: boolean,
};

export default class PreferenceItem extends Component<Props, State> {
  state = {
    is_available: this.props.is_available,
  };

  toggleInclusion = () => {
    const { is_locked, name, is_available, isGuided } = this.props;

    if (isGuided || !is_locked) {
      this.props.updatePref({ name, is_available: !is_available });
    } else {
      return null;
    }
  };

  render() {
    const { name, is_locked, note, is_available, prefCost, isGuided } = this.props;
    const locked = isGuided ? false : is_locked;

    return (
      <Toggler initialOn={true}>
        {({ on, toggle }) => (
          <div className="collapse-holder">
            <div className="collapse-head">
              <Toggle locked={locked} onToggle={this.toggleInclusion} on={is_available} />
              <div className="item">
                {name}
                {is_available &&
                  prefCost !== 0 &&
                  (!isGuided && (
                    <span>
                      $ {prefCost} <i>per person</i>
                    </span>
                  ))}
              </div>
              {note !== '' && (
                <div className="item collapse-arrow" onClick={toggle}>
                  <i className="icon icon-hg-chev-down" />
                </div>
              )}
            </div>

            <Collapse isOpen={on}>
              <div className="description">{note}</div>
            </Collapse>
          </div>
        )}
      </Toggler>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/Preferences/PreferenceItem.jsx